import api from './api'
import API_URLS from '~/core/api-urls'
import store from '~/core/store'
import { translate } from '../core/translate'
import { getSessionParticipants } from '~/selectors/session-details'

const getNextExpiryTimestamp = url => {
  const expiredSeconds = new URL(url).searchParams.get('X-Amz-Expires')
  const seconds = expiredSeconds ? +expiredSeconds : 1800
  const miliseconds = seconds * 1000

  return new Date().getTime() + miliseconds
}

const normalizeScreenshot = (map, screenshot) => {
  const participants = getSessionParticipants(screenshot.sessionId)(store.getState())
  const { name } = participants.find(
    p => p.userId === screenshot.initiatorId
  ) || {}

  map[screenshot.objectId] = {
    link: screenshot.preSignedUrl,
    name: name || translate('guest'),
    timestamp: screenshot.timestamp,
    objectId: screenshot.objectId
  }

  return map
}

const normalizeScreenshots = items => items.reduce(normalizeScreenshot, {})

const normalizeResponse = (resp, sessionId) => {
  const result = {
    [sessionId]: {
      content: normalizeScreenshots(resp.content),
      hasMoreScreenshots: !resp.lastPage,
      lastScreenshotsPageIndex: resp.pageKey
    }
  }

  // base screenshots expiry time on the first page of results
  if (resp.pageKey === 0) {
    result[sessionId].nextExpiryTimestamp = getNextExpiryTimestamp(resp.content[0].preSignedUrl)
  }

  return result
}

export const fetchScreenshots = async (sessionId, lastScreenshotsPageIndex, pageSize) => {
  const pageIndex = lastScreenshotsPageIndex + 1
  let result = await api.get(
    API_URLS.screenshots({ sessionId, pageIndex, pageSize })
  )

  if (api.isErrorResponse(result) || result.length === 0) {
    result = {
      [sessionId]: {
        content: {},
        hasMoreScreenshots: false,
        lastScreenshotsPageIndex
      }
    }
  } else {
    result = {
      content: result,
      pageKey: pageIndex,
      lastScreenshotsPageIndex: result.length !== pageSize
    }
    result = normalizeResponse(result, sessionId)
  }

  return result
}
